import React, { useState } from "react";
import { Button, Divider, Modal, Space, Tag, Tooltip, Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { CHURN_STATUS_META } from "./orgChurn";
import { STATUS_EXPLANATIONS, STATUS_ICONS } from "./OrgChurnStatus";

const { Text, Title, Paragraph } = Typography;

// Ordine di gravità crescente, poi gli stati "non valutati".
const STATUS_ORDER = [
  "ok",
  "login_inactive",
  "creation_inactive",
  "churn_risk",
  "disabled",
  "not_applicable",
  "config_missing",
];

/**
 * Legenda riutilizzabile degli stati churn: un'icona "?" che apre un modal
 * autosufficiente. Si usa con <ChurnLegend /> ovunque serva (pannello org,
 * header colonna lista, ...), senza gestire stato nel genitore.
 */
const ChurnLegend = ({ size = "small" }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Cosa significano gli stati churn?">
        <Button
          type="text"
          size={size}
          icon={<QuestionCircleOutlined />}
          aria-label="Legenda stati churn"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        />
      </Tooltip>

      <Modal
        title="Legenda · Rischio churn"
        open={open}
        onCancel={(e) => {
          e?.stopPropagation?.();
          setOpen(false);
        }}
        footer={null}
        width={620}
      >
        <Title level={5} style={{ marginTop: 0 }}>
          Stati
        </Title>
        <Space direction="vertical" size={10} style={{ width: "100%" }}>
          {STATUS_ORDER.map((status) => {
            const meta = CHURN_STATUS_META[status];
            if (!meta) return null;
            const Icon = STATUS_ICONS[status];

            return (
              <div
                key={status}
                style={{
                  display: "grid",
                  gridTemplateColumns: "150px 1fr",
                  gap: 12,
                  alignItems: "start",
                }}
              >
                <Tag
                  color={meta.color}
                  icon={Icon ? <Icon /> : undefined}
                  style={{ margin: 0, justifySelf: "start" }}
                >
                  {meta.label}
                </Tag>
                <Text type="secondary">{STATUS_EXPLANATIONS[status] || ""}</Text>
              </div>
            );
          })}
        </Space>

        <Divider />

        <Title level={5}>Come funziona</Title>
        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
          Il rischio churn confronta due segnali, ciascuno con la propria soglia
          di inattività configurabile:
        </Paragraph>
        <ul style={{ paddingLeft: 18, marginBottom: 12 }}>
          <li>
            <Text strong>Ultimo login</Text>: giorni dall'ultimo accesso al
            gestionale (esclusi gli accessi dello staff come Super User).
          </li>
          <li>
            <Text strong>Ultima attività operativa</Text>: giorni dall'ultima
            creazione di defunti, prenotazioni servizi, pet o attività su Giotto.
          </li>
        </ul>
        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
          Quando <Text strong>entrambi</Text> i segnali superano la rispettiva
          soglia l'org è in <Text strong>Rischio churn</Text>. Se ne supera solo
          uno, lo stato indica quale (login o attività).
        </Paragraph>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Le soglie possono essere <Text strong>globali</Text> (uguali per tutte
          le org) oppure <Text strong>personalizzate</Text> per la singola org.
        </Paragraph>
      </Modal>
    </>
  );
};

export default ChurnLegend;
